<template>
  <section class="content">
    <div id="overlay" v-if="loading">
      <div class="spinner"></div>
      <br/>
      <h4>Loading...</h4>
    </div>
    <div>
      <div class="box box-info">
        <form class="form-horizontal">
          <div class="box-body">
            <div class="form-group container">
              <div class="col-sm-2" style="margin: 2em 0em 0em 0em;">
                <!-- <Button type="submit"  @click.prevent="searchOrder"
                class="btn btn-primary pull-left">Search</Button> -->
                <Button @click.prevent="searchOrder"
                        class="p-button-raised" label="Search" icon="pi pi-search"/>
              </div>
            </div>
          </div>
        </form>
        <DataTable :value="salesOrderLists" dataKey="id" ref="dt"
                   :paginator="true" editMode="cell" class="p-datatable-gridlines"
                   :rows="10" :filters="filters">
          <Column header="S.N">
            <template #body="sl">{{ sl.index + 1 }}</template>
          </Column>
          <Column header="Date" :sortable="true" field="lastLocationDateFormat" filterMatchMode="contains">
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['lastLocationDateFormat']"/>
            </template>
          </Column>
          <Column header="Time" :sortable="true" field="time" filterMatchMode="contains">
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['time']"/>
            </template>
          </Column>

          <Column header="Name" :sortable="true" field="userDTO.name" filterMatchMode="contains">
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['userDTO.name']"/>
            </template>
          </Column>

          <Column header="User Name" :sortable="true" field="userDTO.username" filterMatchMode="contains">
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['userDTO.username']"/>
            </template>
          </Column>

          <Column header="Location" bodyStyle="text-align: right" :sortable="true" field="lastLocation"
                  filterMatchMode="contains">
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['lastLocation']"/>
            </template>
          </Column>


        </DataTable>
      </div>
    </div>
  </section>
</template>
<script>
import DatePicker from 'vue2-datepicker'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import InputText from 'primevue/inputtext'
import Button from 'primevue/button'

export default {
  name: 'salesOrderReport',
  data() {
    return {
      salesOrderList: [],
      loading: false,
      dialogShow: false,
      filters: {}
      // [{label: 'In Stock', value: 'INSTOCK'},{label: 'Low Stock', value: 'LOWSTOCK'},{label: 'Out of Stock', value: 'OUTOFSTOCK'}]
    }
  },
  mounted() {
  },
  computed: {
    salesOrderLists() {
      return this.$store.state.sales.salesOrderLists
    }
  },
  methods: {
    async searchOrder() {
      this.loading = !this.loading
      let resp = await this.$store.dispatch('loadRidersLastLocation')
      this.loading = false
      if (resp.data.data.length <= 0) {
        this.$toast.add({severity: 'error', summary: '', detail: resp.data.message, life: 10000})
        this.salesOrderList = []
      } else {
        this.salesOrderList = resp.data.data
      }
    }
  },
  components: {
    DatePicker,
    DataTable,
    Column,
    InputText,
    Button
  }
}
</script>
<style scoped src="@../../../static/css/purchase.css">

</style>



// WEBPACK FOOTER //
// trackDeliveryHistory.vue?09a95996